import { motion } from 'framer-motion';
import { LinkedinIcon, TwitterIcon } from 'lucide-react';

interface PlatformToggleProps {
  selectedPlatform: 'linkedIn' | 'x';
  onSelectPlatform: (platform: 'linkedIn' | 'x') => void;
}

const PlatformToggle = ({ selectedPlatform, onSelectPlatform }: PlatformToggleProps) => {
  return (
    <div className="flex flex-col items-center gap-2">
      <div className="flex w-full max-w-[280px] bg-background rounded-lg p-1 border border-border">
        {/* LinkedIn Button */}
        <button 
          className={`relative flex-1 flex items-center justify-center gap-2 py-3 rounded-md transition-all duration-200
            ${selectedPlatform === 'linkedIn' 
              ? 'bg-primary text-white shadow-sm' 
              : 'hover:bg-background-hover text-text-primary'
            }`}
          onClick={() => onSelectPlatform('linkedIn')}
        >
          <LinkedinIcon size={18} className="shrink-0" />
          <span className="font-medium">LinkedIn</span>
        </button>

        {/* X Button */}
        <button 
          className={`relative flex-1 flex items-center justify-center gap-2 py-3 rounded-md transition-all duration-200
            ${selectedPlatform === 'x' 
              ? 'bg-primary text-white shadow-sm' 
              : 'hover:bg-background-hover text-text-primary'
            }`}
          onClick={() => onSelectPlatform('x')}
        >
          <TwitterIcon size={18} className="shrink-0" />
          <span className="font-medium">X</span>
        </button>
      </div>

      {/* Optional: Platform description */}
      <motion.p 
        key={selectedPlatform}
        initial={{ opacity: 0, y: -5 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-sm text-text-primary/75"
      >
        {selectedPlatform === 'linkedIn' 
          ? 'Create professional content for LinkedIn'
          : 'Create engaging tweets for X'
        }
      </motion.p>
    </div>
  );
};

export default PlatformToggle; 